"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    fontImports: function() {
        return fontImports;
    },
    fontSrcList: function() {
        return fontSrcList;
    },
    mainFont: function() {
        return mainFont;
    },
    useDefaultFont: function() {
        return useDefaultFont;
    }
});
const _react = require("react");
const defaultFont = "Roboto";
const languageSpecificFonts = {
    ja: "Noto Sans JP"
};
const mainFont = "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=block";
const fontSrcList = [
    mainFont,
    "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&display=block"
];
const fontImports = fontSrcList.map((src)=>'@import url("'.concat(src, '");')).join("\n");
const currentLang = ()=>{
    if (typeof document === "undefined") {
        return "en";
    }
    var _document_documentElement_getAttribute;
    return (_document_documentElement_getAttribute = document.documentElement.getAttribute("lang")) !== null && _document_documentElement_getAttribute !== void 0 ? _document_documentElement_getAttribute : "en";
};
function useDefaultFont() {
    const [lang, setLang] = (0, _react.useState)(currentLang());
    (0, _react.useEffect)(()=>{
        const observer = new MutationObserver(()=>setLang(currentLang()));
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: [
                "lang"
            ]
        });
        return ()=>observer.disconnect();
    }, []);
    var _languageSpecificFonts_lang;
    return (_languageSpecificFonts_lang = languageSpecificFonts[lang]) !== null && _languageSpecificFonts_lang !== void 0 ? _languageSpecificFonts_lang : defaultFont;
}

//# sourceMappingURL=useDefaultFont.js.map